import React, {
  useContext,
  useEffect,
  useRef,
  useMemo,
  useCallback,
  useState,
} from 'react'
import { fields } from '../AvailableFields/FieldDefinitions'
import FieldProperty from './components/FieldProperty/FieldProperty'
import PanelSidebarEditor from '../../../../components/Sidebar/Builder/PanelSidebarEditor/PanelSidebarEditor'
import { BuilderContext } from '../store/store.Builder'
import { getIsExternal } from '../../../../utils/sessionManagement'

import EmailNotificationsGroupInput from './components/Inputs/EmailNotificationsGroupInput/EmailNotificationsGroupInput'
import RestrictedSubmissionsInput from './components/Inputs/RestrictedSubmissionsInput/RestrictedSubmissionsInput'
import GenericInput from './components/Inputs/GenericInput/GenericInput'
import MarginInput from './components/Inputs/MarginInput/MarginInput'
import PaddingInput from './components/Inputs/PaddingInput/PaddingInput'
import OptionsInput from './components/Inputs/OptionsInput/OptionsInput'
import ColorInput from './components/Inputs/ColorInput/ColorInput'
import TypeInput from './components/Inputs/TypeInput/TypeInput'
import BorderRadiusInput from './components/Inputs/BorderRadiusInput/BorderRadiusInput'
import SizeInput from './components/Inputs/SizeInput/SizeInput'
import FontFamilyInput from './components/Inputs/FontFamilyInput/FontFamilyInput'
import DescriptionVisibleInput from './components/Inputs/DescriptionVisibleInput/DescriptionVisibleInput'
import FontWeightInput from './components/Inputs/FontWeightInput/FontWeightInput'
import LetterSpacingInput from './components/Inputs/LetterSpacingInput/LetterSpacingInput'
import TextAlignInput from './components/Inputs/TextAlignInput/TextAlignInput'
import BoxShadowInput from './components/Inputs/BoxShadowInput/BoxShadowInput'
import WidthInput from './components/Inputs/WidthInput/WidthInput'
import TextAreaInput from './components/Inputs/TextAreaInput/TextAreaInput'
import ExpiryDateInput from './components/Inputs/ExpiryDateInput/ExpiryDateInput'
import TextTransformInput from './components/Inputs/TextTransformInput/TextTransformInput'
import TypeHeaderInput from './components/Inputs/TypeHeaderInput/TypeHeaderInput'
import MaxLengthInput from './components/Inputs/MaxLengthInput/MaxLengthInput'

import styles from './SidebarEditor.module.css'
import { SvgHash } from '../../../../components/svg/SvgComponents'
import { observer } from 'mobx-react-lite'
import { toJS } from 'mobx'
import { Tooltip, message } from 'antd'
export const styleNames = {
  title_form: {
    label: 'Titre du Formulaire',
    title: 'Titre du Formulaire',
    Component: TextAreaInput,
    category: 'Données',
  },
  is_active: {
    label: 'Formulaire actif ?',
    title: 'Formulaire actif ?',
    Component: DescriptionVisibleInput,
    category: 'Données',
  },
  success_message: {
    label: 'Message de succés',
    title: 'Message de succés',
    Component: TextAreaInput,
    category: 'Données',
  },
  is_collaborative_mode: {
    label: 'Mode réponses éditables ?',
    title: 'Mode réponses éditables ?',
    Component: DescriptionVisibleInput,
    category: 'Données',
  },
  show_answerAgain_button: {
    label: 'Afficher bouton après validation',
    title: 'Afficher bouton après validation',
    Component: DescriptionVisibleInput,
    category: 'Données',
  },
  allow_authenticated_submissions: {
    label: 'Répondants (Internes uniquement)',
    title: 'Répondants (Internes uniquement)',
    Component: DescriptionVisibleInput,
    category: 'Données',
  },
  allow_unauthenticated_submissions: {
    label: 'Répondants (Tout public)',
    title: 'Répondants (Tout public)',
    Component: DescriptionVisibleInput,
    category: 'Données',
  },

  allow_restricted_submissions: {
    label: 'Répondants personnalisés',
    title: 'Répondants personnalisés',
    Component: RestrictedSubmissionsInput,
    category: 'Données',
  },

  allow_email_notifications: {
    label: 'Notifications par email',
    title: 'Notifications par email',
    Component: EmailNotificationsGroupInput,
    category: 'Données',
  },

  anonymous_responses: {
    label: 'Réponses anonymes ?',
    title: 'Réponses anonymes ?',
    Component: DescriptionVisibleInput,
    category: 'Données',
  },

  one_response_per_person: {
    label: '[INTERNE] Une réponse par personne',
    title: '[INTERNE] Une réponse par personne',
    Component: DescriptionVisibleInput,
    category: 'Données',
  },

  show_send_btn: {
    label: 'Afficher le bouton Envoyer ?',
    title: 'Afficher le bouton Envoyer ?',
    Component: DescriptionVisibleInput,
    category: 'Données',
  },

  show_header: {
    label: 'Afficher une en-tête ?',
    title: 'Afficher une en-tête ? ',
    Component: DescriptionVisibleInput,
    category: 'Données',
  },

  header_type: {
    label: "Type d'en-tête",
    title: "Type d'en-tête",
    Component: TypeHeaderInput,
    category: 'Données',
  },

  expiry_date: {
    label: 'Date de validité',
    title: 'Date de validité',
    Component: ExpiryDateInput,
    category: 'Données',
  },
  url_target: {
    label: 'Lien / URL',
    title: 'Lien / URL',
    Component: TextAreaInput,
    category: 'Données',
  },

  max_responses: {
    label: 'Réponses max autorisées',
    title: 'Réponses max autorisées',
    Component: SizeInput,
    category: 'Données',
  },
  gap: {
    label: 'Espace entre les blocs',
    title: 'Espace entre les blocs',
    Component: SizeInput,
    category: 'Styles',
  },
  margin: {
    label: 'Marge extérieure',
    title: 'Marge extérieure',
    Component: MarginInput,
    category: 'Styles',
  },
  padding: {
    label: 'Marge intérieure',
    title: 'Marge intérieure',
    Component: MarginInput,
    category: 'Styles',
  },
  color: {
    label: 'Couleur du texte',
    title: 'Couleur du texte',
    Component: ColorInput,
    category: 'Styles',
  },
  label: {
    label: 'Titre',
    title: 'Titre',
    Component: GenericInput,
    category: 'Données',
  },
  // type: {
  //   label: 'Type',
  //   title: 'Type',
  //   Component: TypeInput,
  //   category: 'Données',
  // },
  placeholder: {
    label: 'Placeholder',
    title: 'Texte de substitution',
    Component: GenericInput,
    category: 'Données',
  },
  fontSize: {
    label: 'Taille du texte',
    title: 'Taille du texte',
    Component: SizeInput,
    category: 'Styles',
  },
  fontFamily: {
    label: 'Police du texte',
    title: 'Police',
    Component: FontFamilyInput,
    category: 'Styles',
  },
  fontWeight: {
    label: 'Épaisseur du texte',
    title: 'Épaisseur du texte',
    Component: FontWeightInput,
    category: 'Styles',
  },
  letterSpacing: {
    label: 'Espacement des lettres',
    title: 'Espacement des lettres',
    Component: LetterSpacingInput,
    category: 'Styles',
  },
  textTransform: {
    label: 'Majuscule',
    title: 'Majuscule',
    Component: TextTransformInput,
    category: 'Styles',
  },
  justifyContent: {
    label: 'Alignement du texte',
    title: 'Alignement du texte',
    Component: TextAlignInput,
    category: 'Styles',
  },
  justifySelf: {
    label: 'Alignement',
    title: 'Alignement',
    Component: TextAlignInput,
    category: 'Styles',
  },
  alignItems: {
    label: 'Alignement interne',
    title: 'Alignement interne',
    Component: TextAlignInput,
    category: 'Styles',
  },
  backgroundColor: {
    label: 'Couleur du fond',
    title: 'Couleur du fond',
    Component: ColorInput,
    category: 'Styles',
  },
  borderRadius: {
    label: 'Courbure de la bordure',
    title: 'Courbure de la bordure',
    Component: SizeInput,
    category: 'Styles',
  },
  borderWidth: {
    label: 'Epaisseur de la bordure',
    title: 'Epaisseur de la bordure',
    Component: SizeInput,
    category: 'Styles',
  },
  borderColor: {
    label: 'Couleur de la bordure',
    title: 'Couleur de la bordure',
    Component: ColorInput,
    category: 'Styles',
  },
  boxShadow: {
    label: 'Ombre',
    title: 'Ombre',
    Component: BoxShadowInput,
    category: 'Styles',
  },
  width: {
    label: 'Largeur',
    title: 'Largeur',
    Component: WidthInput,
    category: 'Styles',
  },
  minWidth: {
    label: 'Largeur minimum',
    title: 'Largeur minimum',
    Component: WidthInput,
    category: 'Styles',
  },
  maxWidth: {
    label: 'Largeur maximum',
    title: 'Largeur maximum',
    Component: WidthInput,
    category: 'Styles',
  },
  height: {
    label: 'Hauteur',
    title: 'Hauteur',
    Component: WidthInput,
    category: 'Styles',
  },
  options: {
    label: 'Options',
    title: 'Options',
    Component: OptionsInput,
    category: 'Données',
  },
  description: {
    label: 'Description',
    title: 'Description',
    Component: TextAreaInput,
    category: 'Données',
  },
  descriptionVisible: {
    label: 'Afficher description',
    title: 'Afficher description',
    Component: DescriptionVisibleInput,
    category: 'Données',
  },
  is_unique_key: {
    label: "Élimination d'options ?",
    title: "Élimination d'options ?",
    Component: DescriptionVisibleInput,
    category: 'Données',
  },
  is_axis_key: {
    label: "Clé d'analyse ?",
    title: "Clé d'analyse ?",
    Component: DescriptionVisibleInput,
    category: 'Données',
  },
  required: {
    label: 'Requis',
    title: 'Requis',
    Component: DescriptionVisibleInput,
    category: 'Données',
  },
  has_max_length: {
    label: 'Nombre de caractères max',
    title: 'Nombre de caractères max',
    Component: MaxLengthInput,
    category: 'Données',
  },
}

const SidebarEditor = observer(() => {
  const copyIDField = (id) => {
    try {
      navigator.clipboard.writeText(`${id}`)
      message.success("L'identifiant a été copié dans le presse-papiers")
    } catch (error) {
      message.error(
        "Une erreur s'est produite lors de la copie de l'identifiant."
      )
    }
  }

  const renderCountRef = useRef(0)
  renderCountRef.current += 1
  const [selectedCategory, setSelectedCategory] = useState('Données')

  useEffect(() => {
    console.log(`SidebarEditor render count: ${renderCountRef.current}`)
  })

  const builderContext = useContext(BuilderContext)

  useEffect(() => {
    console.log('START', toJS(builderContext.selectedField))
    if (builderContext.selectedField) {
      const initialStyle = Object.keys(styleNames).reduce((style, name) => {
        // Vérifie d'abord si la clé est dans 'design'
        if (
          builderContext.selectedField.design &&
          builderContext.selectedField.design.hasOwnProperty(name)
        ) {
          style[name] =
            builderContext.selectedField.design[name] === undefined
              ? ''
              : builderContext.selectedField.design[name]
        } else if (builderContext.selectedField.hasOwnProperty(name)) {
          // Si la clé n'est pas dans 'design', vérifie si elle est dans 'selectedField'
          style[name] =
            builderContext.selectedField[name] === undefined
              ? ''
              : builderContext.selectedField[name]
        }

        return style
      }, {})

      builderContext.setStyle(initialStyle)
    }
    console.log(
      'SIDEBAREDITOR SELECTEDFIELD',
      toJS(builderContext.selectedField)
    )
  }, [builderContext.selectedField])

  // Fonction pour vérifier si l'utilisateur est externe
  const isUserExternal = useCallback(() => {
    return getIsExternal()
  }, [])

  const editableProperties = useMemo(() => {
    if (!builderContext.selectedField) {
      return []
    }

    const fieldDefinition = fields.find(
      (field) => field.type === builderContext.selectedField.type
    )

    const propertyNames = Object.keys(styleNames).filter((name) => {
      // Si l'utilisateur est externe, on cache certaines propriétés
      if (isUserExternal()) {
        if (
          name === 'show_header' ||
          name === 'header_type' ||
          name === 'allow_authenticated_submissions' ||
          name === 'allow_restricted_submissions'
        ) {
          return false
        }
      }

      const hasProperty =
        builderContext.selectedField.hasOwnProperty(name) ||
        (builderContext.selectedField.design &&
          builderContext.selectedField.design.hasOwnProperty(name))

      const isPropertyAllowed =
        !fieldDefinition ||
        fieldDefinition.hasOwnProperty(name) ||
        (fieldDefinition.design && fieldDefinition.design.hasOwnProperty(name))

      return hasProperty && isPropertyAllowed
    })

    return propertyNames
  }, [builderContext.selectedField, isUserExternal])

  const categories = [
    {
      name: 'Bloc',
      type: 'field',
      propertyFieldDefinition: 'design',
    },
    {
      name: 'Titre',
      type: 'label',
      propertyFieldDefinition: 'label_design',
    },
    {
      name: 'Description',
      type: 'description',
      propertyFieldDefinition: 'description_design',
    },
    {
      name: 'Input',
      type: 'input',
      propertyFieldDefinition: 'input_design',
    },
  ]

  const handleCategoryClick = (category) => {
    console.log(category)

    const validTypes = ['input', 'label', 'description', 'field']

    if (validTypes.includes(category.type)) {
      builderContext.setSelectedFieldByIdAndType(
        builderContext.selectedField.id,
        category.type
      )
      console.log(category.type, toJS(builderContext.selectedField))
    } else {
      console.log('Type non reconnu')
    }
  }

  const handleChange = useCallback(
    (name, value) => {
      let newValue
      if (value && value.target !== undefined) {
        newValue = value.target.value
      } else {
        newValue = value
      }

      console.log('Before update:')
      console.log('name:', name)
      console.log('newValue:', newValue)
      console.log('selectedField:', toJS(builderContext.selectedField))
      console.log('style:', toJS(builderContext.style))
      console.log('styleForm:', toJS(builderContext.styleForm))

      // If property is part of design, update it in the design object
      let updatedField
      if (name in styleNames && styleNames[name].category === 'Styles') {
        updatedField = {
          ...builderContext.selectedField,
          design: {
            ...(builderContext.selectedField.design || {}),
            [name]: newValue,
          },
        }
      } else {
        updatedField = { ...builderContext.selectedField, [name]: newValue }
      }

      // Lorsque le type de champ est modifié, nous ajustons les propriétés à celles nécessaires pour le nouveau type
      if (name === 'type') {
        console.log('Changement de type détecté')

        const newFieldDefinition = fields.find(
          (field) => field.type === newValue
        )

        if (newFieldDefinition) {
          console.log(
            'Nouvelle définition de champ trouvée:',
            newFieldDefinition
          )

          console.log(
            'Composition du champ actuel (updatedField):',
            updatedField
          )

          // Vérifiez si "input_design" doit être copié de newFieldDefinition vers updatedField
          if (
            newFieldDefinition.hasOwnProperty('input_design') &&
            !updatedField.hasOwnProperty('input_design')
          ) {
            console.log('Ajout de la propriété input_design à updatedField')
            if (builderContext.input_default_design) {
              updatedField.input_design = {
                ...builderContext.input_default_design,
              }
            } else {
              updatedField.input_design = { ...newFieldDefinition.input_design }
            }
          }

          // Ajoutez les nouvelles propriétés par défaut pour le nouveau type
          for (let key of Object.keys(newFieldDefinition)) {
            console.log(`Vérification de la clé: ${key}`)

            if (
              !updatedField.hasOwnProperty(key) &&
              styleNames.hasOwnProperty(key)
            ) {
              console.log(`Ajout de la nouvelle propriété par défaut: ${key}`)

              if (styleNames[key].category === 'Styles') {
                updatedField.design = {
                  ...updatedField.design,
                  [key]: newFieldDefinition[key],
                }
                console.log(
                  `Nouvelle valeur ajoutée dans 'design': ${key} = ${newFieldDefinition[key]}`
                )
              } else {
                updatedField[key] = newFieldDefinition[key]
                console.log(
                  `Nouvelle valeur ajoutée: ${key} = ${newFieldDefinition[key]}`
                )
              }
            }
          }

          // Supprimez les propriétés qui ne sont pas nécessaires pour le nouveau type
          for (let key of Object.keys(updatedField)) {
            console.log(`Vérification de la clé pour suppression: ${key}`)

            if (
              !newFieldDefinition.hasOwnProperty(key) &&
              key !== 'type' &&
              styleNames.hasOwnProperty(key)
            ) {
              console.log(`Tentative de suppression de la propriété: ${key}`)

              console.log(
                'updatedField avant suppression: ',
                JSON.stringify(updatedField, null, 2)
              )

              if (styleNames[key].category === 'Styles') {
                const { [key]: removed, ...restDesign } = updatedField.design
                updatedField.design = restDesign
                console.log(`Propriété ${key} supprimée de 'design'`)
              } else {
                delete updatedField[key]
                console.log(`Propriété ${key} supprimée`)
              }

              console.log(
                'updatedField après suppression: ',
                JSON.stringify(updatedField, null, 2)
              )
            }
          }
        } else {
          console.error(
            `Définition de champ pour le type ${newValue} non trouvée.`
          )
        }
      }

      builderContext.handleFieldUpdate(updatedField)

      console.log('After update:')
      console.log('updatedField', updatedField)
      console.log('selectedField:', toJS(builderContext.selectedField))
      console.log('style:', toJS(builderContext.style))
      console.log('styleForm:', toJS(builderContext.styleForm))
    },
    [builderContext.selectedField, builderContext.handleFieldUpdate, styleNames]
  )

  // Fonction qui vérifie si le typeSelected est dans categories
  const isSelectedTypeInCategories = () => {
    return categories.some(
      (category) => category.type === builderContext.selectedField.typeSelected
    )
  }

  if (!builderContext.selectedField) {
    return null
  }

  return (
    <div
      className={`${styles.sidebarEditor} ${
        builderContext.isSidebarEditorOpen ? '' : styles.hidden
      }`}
    >
      <div className={styles.header}>
        <div className={styles.categorySelector}>
          <div
            className={`${styles.titlecategory} ${
              selectedCategory === 'Données' ? styles.activecategory : ''
            }`}
            onClick={() => setSelectedCategory('Données')}
          >
            Données
          </div>
          <div
            className={`${styles.titlecategory} ${
              selectedCategory === 'Styles' ? styles.activecategory : ''
            }`}
            onClick={() => setSelectedCategory('Styles')}
          >
            Design
          </div>
        </div>
      </div>

      {builderContext.selectedFieldParent && isSelectedTypeInCategories() && (
        <div className={styles.header}>
          <div className={styles.categorySelector}>
            {categories.map((category) => {
              // Rechercher la définition du champ correspondant au type de selectedFieldParent
              const fieldDefinition = fields.find(
                (field) =>
                  field.type === builderContext.selectedFieldParent.type
              )

              // Vérifier si la propriété propertyFieldDefinition existe dans cette définition
              if (
                fieldDefinition &&
                category.propertyFieldDefinition in fieldDefinition
              ) {
                return (
                  <div
                    key={category.name}
                    className={`${styles.titlecategory} ${
                      builderContext.selectedField?.typeSelected ===
                      category.type
                        ? styles.activecategory
                        : ''
                    }`}
                    onClick={() => handleCategoryClick(category)}
                  >
                    {category.name}
                  </div>
                )
              }
              return null // Si propertyFieldDefinition n'existe pas, ne rien afficher pour cette catégorie.
            })}
          </div>
        </div>
      )}

      <div className={styles.header2}>
        <Tooltip
          title={
            builderContext.selectedField.typeSelected !== 'form'
              ? builderContext.selectedField.id
              : builderContext.selectedField.url_code
          }
          placement="bottom"
          color="black"
          key={
            builderContext.selectedField.typeSelected !== 'form'
              ? builderContext.selectedField.id
              : builderContext.selectedField.url_code
          }
        >
          <div
            className={styles.container__header3}
            onClick={() =>
              copyIDField(
                builderContext.selectedField.typeSelected !== 'form'
                  ? builderContext.selectedField.id
                  : builderContext.selectedField.url_code
              )
            }
          >
            <div className={styles.logo__header2}>
              <SvgHash />
            </div>
            <div className={styles.name__of__field}>
              ID du {builderContext.selectedField.typeSelected}
            </div>
          </div>
        </Tooltip>
      </div>

      <div className={styles.container__inputs}>
        {editableProperties
          .filter((name) => styleNames[name].category === selectedCategory)
          .map((name) => {
            const { Component, label, title } = styleNames[name]
            return (
              <FieldProperty
                key={name}
                name={name}
                label={label}
                title={title}
                value={builderContext.style[name]}
                onChange={
                  name === 'options'
                    ? (value) => handleChange(name, value)
                    : typeof builderContext.style[name] === 'boolean'
                    ? (value) => handleChange(name, value)
                    : (event) => handleChange(name, event)
                }
                Component={Component}
              />
            )
          })}
      </div>
    </div>
  )
})

export default SidebarEditor
